<template>
  <footer class="footer">
    <div class="footer__container">
        <a class="footer__logo hide_mobile" href="/"><img src="../assets/logo2.svg" alt="Online Kitchen"></a>
        <ul class="footer__list">
            <li class="footer__item" v-for="(item, index) in nav" :key="index">
                <a class="footer__link center__fix" :href="item.link">{{item.title}}</a>
            </li>
        </ul>
        <div class="footer__social-buttons" style="flex-wrap:wrap;" >
            <a
                class="footer__social-btn"
                target="_blank"
                v-for="(item, index) in socials"
                :key="index"
                :href="item.link"
            >
                <img class="footer__social-btn" :src="item.icon" :alt="item.title">{{item.title}}
            </a>
        </div>
        <a class="footer__logo show_mobile" href="/"><img src="../assets/logo2.svg" alt="Online Kitchen"></a>
    </div>
  </footer>
</template>
<script>
import ICON_FB from '../assets/fb.svg';
import ICON_VK from '../assets/vkontakte.svg';
import ICON_INST from '../assets/inst.svg';
import ICON_YB from '../assets/youtube-icon.svg';
export default {
    data: () => ({
        nav: [
            { link: 'https://online-kitchen.ru/dogovor-oferty', title: 'Публичная оферта' },
            { link: 'https://online-kitchen.ru/avtorskoe-pravo', title: 'Авторское право' },
            { link: 'https://online-kitchen.ru/disklejmer', title: 'Дисклеймер' },
        ],
        socials: [
            { link: 'https://www.facebook.com/Online-Kitchen-448822149221054/', icon: ICON_FB, title: 'Facebook' },
            { link: 'https://vk.com/online_kitchen_ru', icon: ICON_VK, title: 'Вконтакте' },
            { link: 'https://www.instagram.com/online_kitchen.ru/', icon: ICON_INST, title: 'Instagram' },
            { link: 'https://www.youtube.com/channel/UCnSvoEZ2TDozFSR6SerB2YA', icon: ICON_YB, title: 'YouTube' },
        ]
    })
}
</script>
<style lang="scss" scoped>

.hide_mobile {
    display: flex !important;
}

.show_mobile {
    display: none !important;
}

@media (max-width: 768px) {
    .hide_mobile {
        display: none !important;
    }
    .show_mobile {
        display: flex !important;
    }
}

.footer {
    background-color: #b9b9b9;
    transform: translateX(-78px);
    width: calc(100% + 78px);
    
    &__container {
        position: relative;
        display: flex;
        flex-wrap: wrap;
        align-items: flex-start;
        justify-content: space-between;
        padding: 20px 10px;
    }

    &__logo {
        display: flex;
        align-items: center;
        justify-content: center;
        width: 90px;
        height: 70px;

        img {
            display: block;
            max-width: 100%;
            height: auto;
        }
    }

    &__list {
        display: flex;
        flex-wrap: wrap;
        width: 100%;
        margin: 0;
        padding: 0;
        list-style: none;
    }

    &__item {
        width: 50%;
        width: 33.33333333333333%;
    }

    &__link {
        padding-right: 7px;
        font-size: 13px;
        line-height: 1.2;
        color: #fff;
        text-decoration: none;

        &:hover {
            text-decoration: underline;
        }
    }

    &__social-buttons {
        display: flex;
        margin-top: 30px;
    }

    &__social-btn {
        display: block;
        width: 20px;
        height: 20px;
        margin-right: 7px;
        font-size: 0;
        line-height: 0;
        background-repeat: no-repeat;
        background-position: center;
        background-size: contain;

        &:last-of-type {
            margin-right: 0;
        }
    }

    @media (min-width: 1920px) {
        &__container {
            padding: 30px 15px;
        }

        &__logo {
            width: 150px;
            height: 50px;
        }
        
        &__link {
            font-size: 18px;
        }
        
        &__social-btn {
            width: 30px;
            height: 30px;
            margin-right: 20px;
        }
    }

    @media (min-width: 1825px) {
        &__container {
            width: 1825px;
            padding: 0;
        }
    }

    @media (max-width: 575.98px) {
        transform: translateX(0px);
        width: unset;
    }

    @media (min-width: 768px) {

        &__container {
            width: 720px;
            margin: 0 auto;
            align-items: center;
            justify-content: center;
            padding: 25px 0;
        }
        
        &__logo {
            width: 100px;
            margin-right: auto;
        }
        
        &__list {
            display: block;
            width: auto;
            column-count: 2;
        }
        
        &__item {
            width: auto;
            margin-right: 20px;
        }
        
        &__link {
            font-size: 16px;
            line-height: 1.5;
        }
        
        &__social-buttons {
            margin-left: auto;
            margin-top: 0px;
        }
        
        &__social-btn {
            width: 25px;
            height: 25px;
            margin-right: 10px;
        }
    }

    @media (min-width: 1170px) {
        &__container {
            width: 1170px !important;
            padding: 30px 15px !important;
        }
        
        &__logo {
            width: 130px;
            height: 40px;
        }
        
        &__list {
            flex-grow: 0;
            display: flex;
            align-items: center;
            column-count: 1;
        }
        
        &__item {
            margin-right: 35px;
        }
        
        &__social-btn {
            margin-right: 15px;
        }
    }
}
</style>
